module.exports = __webpack_public_path__ + "static/img/secure-icon.dc2c9353.png";